<template>
    <span v-if="mostrarBtnCancelarDespViagem" class="ml-1">
        <span class="text-danger">
            <i
                class="fa fa-times-circle-o fa-lg icon-button"
                title="Cancelar despesa de viagem"
                @click.stop="abrirModal()"
            ></i>
        </span>
        <b-modal v-model="mostrarModal">
            <div slot="modal-title">Contratação - Cancelar Desp. Viagem</div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Despesa de viagem</label><br />
                        <span
                            ><strong>{{ despViagem.nome }}</strong></span
                        >
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Justificativa</label>
                        <b-form-textarea
                            v-model="justificativa"
                            :rows="4"
                            @input="$v.justificativa.$touch()"
                            :state="$v.justificativa.$error ? false : null"
                        ></b-form-textarea>
                        <b-form-invalid-feedback
                            >A justificativa é
                            obrigatória</b-form-invalid-feedback
                        >
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button
                    variant="secondary"
                    @click.stop="fecharModal()"
                    class="mr-2"
                    >Cancelar</b-button
                >
                <b-button
                    variant="primary"
                    :disabled="$v.$invalid"
                    @click.stop="confirmarCancelarDespViagem()"
                    >Salvar</b-button
                >
            </div>
        </b-modal>
    </span>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

export default {
    props: {
        despViagem: {
            type: Object,
            default: () => ({})
        },

        contratacoesServicos: {
            type: Object,
            required: true,
            default: () => ({})
        }
    },

    data() {
        return {
            mostrarModal: false,
            erros: [],
            justificativa: ''
        }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true
        },

        fecharModal() {
            this.mostrarModal = false
            this.reset()
        },

        reset() {
            this.justificativa = ''
            this.erros = []
            this.$nextTick(() => {
                this.$v.$reset()
            })
        },

        confirmarCancelarDespViagem() {
            this.$swal({
                title: 'Cancelar Despesa de Viagem',
                html: `Confirma o cancelamento da despesa de viagem ${this.despViagem.nome} da contratação ${this.despViagem.codContratacao}?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.cancelarDespViagem()
                }
            })
        },

        cancelarDespViagem() {
            this.$store.dispatch('addRequest')
            let despViagemCanceladaDto = {
                codContratacao: this.despViagem.codContratacao,
                tipo: this.despViagem.nome == 'CONSULTORIA' ? 0 : 1,
                justificativa: this.justificativa
            }
            this.contratacoesServicos
                .cancelarDespViagem(despViagemCanceladaDto)
                .then((response) => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Registro atualizado com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('obterAtualizacao')
                            this.fecharModal()
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        }
    },

    computed: {
        mostrarBtnCancelarDespViagem() {
            return (
                this.$temAcesso('CRED-UABS-CONT-05') &&
                !this.despViagem.pagamento &&
                this.despViagem.valorDespViagem > 0 &&
                !this.despViagem.cancelada
            )
        }
    },

    validations: {
        justificativa: {
            required
        }
    }
}
</script>
